import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { Button } from '@fiverr-private/fit';
import { numberFormat } from '@fiverr-private/localization';
import { getFilesCount } from '../../selectors/files';
import { REJECTION_REASONS_STEP } from '../PreRevisionWizard/const';
import { getOnRevisionAcceptanceQuestion, getOnAcceptDeliveryBtnClick } from '../../selectors/callbacks';
import * as Translations from '../../providers/i18n';

import './style.scss';

export const PreRevisionQuestionOnDelivery = ({ fileCount, onDeliveryRejection,
    onRevisionAcceptanceQuestion, onAcceptDeliveryBtnClick, i18n }) => {

    const onNoClick = () => {
        onRevisionAcceptanceQuestion('No');
        onDeliveryRejection(REJECTION_REASONS_STEP);
    };

    const onYesClick = () => {
        onRevisionAcceptanceQuestion('Yes');
        onAcceptDeliveryBtnClick();
    };

    const formattedFileCount = numberFormat(fileCount, {
        fallbackValue: fileCount
    });

    return (
        <div className="pre-revision-question-on-delivery">
            <i className="icn-delivery-files"/>
            <p>
                {i18n.t('attachments_preview.pre_revision.are_you_pleased.prefix')}
                {' '}
                <b>{i18n.t('attachments_preview.pre_revision.are_you_pleased.files', { count: formattedFileCount })}</b>
                {' '}
                {i18n.t('attachments_preview.pre_revision.are_you_pleased.suffix')}
            </p>
            <Button onClick={onYesClick}>{i18n.t('attachments_preview.general.yes')}</Button>
            <Button onClick={onNoClick}>{i18n.t('attachments_preview.general.no')}</Button>
        </div>
    );
};

PreRevisionQuestionOnDelivery.propTypes = {
    fileCount: PropTypes.number.isRequired,
    onDeliveryRejection: PropTypes.func.isRequired,
    onAcceptDeliveryBtnClick: PropTypes.func.isRequired,
    onRevisionAcceptanceQuestion: PropTypes.func.isRequired,
    i18n: PropTypes.shape({
        t: PropTypes.func
    })
};

const mapStateToProps = (state) => ({
    fileCount: getFilesCount(state),
    onAcceptDeliveryBtnClick: getOnAcceptDeliveryBtnClick(state),
    onRevisionAcceptanceQuestion: getOnRevisionAcceptanceQuestion(state)
});

export default compose(
    Translations.connect,
    connect(mapStateToProps))(PreRevisionQuestionOnDelivery);
